import React, { useState } from 'react';
import ShareSocial from '../ShareSocial';
import SubscriberLink from '../forms/SubscriberLink';
import Modal from '../Modal';

interface StartupEcosystemCard {
    id: string;
    heading: string;
    description: string;
    image?: string;
    number?: string;
    alt?: string;
}

interface StartupEcosystemData {
    tagline: string;
    heading: string;
    description: string;
    pdfLink: string;
    buttonText: string;
    content: string[];
    cards: StartupEcosystemCard[];
}

interface StartupEcosystemProps {
    data: StartupEcosystemData;
}

const StartupEcosystem: React.FC<StartupEcosystemProps> = ({
    data
}) => {
    const [modalImageUrl, setModalImageUrl] = useState<string | null>(null);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const openModal = (imageUrl: string) => {
        setModalImageUrl(imageUrl);
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
        setModalImageUrl(null);
    };

    return (
        <section id="startup-ecosystem" className="section-regular background-cream">
            <div className="container-large">
                <div className="bento-w-heading">
                    <div className="heading-wrap">
                        <div className="limited-heading-set">
                            <div className="tagline-heading">{data.tagline}</div>
                            <div className="heading-set-3">
                                <h2 className="h3-heading">{data.heading}</h2>
                                <div className="description">{data.description}</div>
                            </div>
                        </div>
                        <div className="action-side">
                            <SubscriberLink href={data.pdfLink} target="_blank" className="button-left-icon w-inline-block">
                                <div className="button-icon-left"></div>
                                <div className="text-block-4">{data.buttonText}</div>
                            </SubscriberLink>
                            <ShareSocial />
                        </div>
                    </div>

                    <div className="circle-container">
                        {data.content?.map((item) => (
                            <div className="circle">{item}</div>
                        ))}
                    </div>

                    <div className="bento-grid-wrapper">
                        <div className="w-layout-grid bento-grid _3-columns">
                            {data.cards.map((card) => (
                                <div key={card.id} id={card.id} className={`bento-card ${card.image ? '' : 'bg startup'}`}>
                                    {card.number && <h1 className="number-display yellow">{card.number}</h1>}
                                    <div className="bento-card-header">
                                        <div className="wrap-v-small">
                                            <h3 className="h4-heading">
                                                <strong>{card.heading}</strong>
                                            </h3>
                                            <p className="description">{card.description}</p>
                                            {card.image && (
                                                <img
                                                    src={card.image}
                                                    alt={card.alt || 'Image'}
                                                    loading="lazy"
                                                    sizes="80px"
                                                    className="bento-card-image"
                                                    onClick={() => openModal(card.image || "")}
                                                />
                                            )}
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
            {isModalOpen && (
                <Modal isOpen={isModalOpen} onClose={closeModal}>
                    {/* Pass dynamic content here */}
                    <img src={modalImageUrl || ""} />
                </Modal>
            )}
        </section>
    );
};

export default StartupEcosystem;
